import { signal } from "@/react/core/reactive.ts";
import { getDeviceId } from "@/shared/getDeviceId.ts";

//master id signal
export const [masterId, setMasterId] = signal<string | null>((() => {
  return localStorage.getItem('masterId');
})());
export const [isMaster, setIsMaster] = signal<boolean>((() => {
  return localStorage.getItem('masterId') === getDeviceId();
})())